enum SynthesisStepAccordionKey {
  trackers = 'trackers',
}

export default SynthesisStepAccordionKey;
